import React from 'react';
import LoadingOverlay from 'react-loading-overlay';
import {
  Typography,
  CircularProgress
} from '@material-ui/core';
LoadingOverlay.propTypes = undefined; // Workaround for internal propTypes error on LoadingOverlay styles prop

const LoadingOverlayWrapper = ({ active, message, children, className, background, spinner, zIndex, style = {}  }) => {
  return (
    <LoadingOverlay
      active={active}
      className={className}
      spinner={spinner || <CircularProgress />}
      text={<Typography variant='subtitle2' style={{ marginTop: 8 }}> {message ? message : ''} </Typography>}
      styles={{
        wrapper: (base) => ({
          ...base,
          ...style
        }),
        overlay: (base) => ({
          ...base,
          background: background || 'rgba(255, 255, 255, 0.9)',
          zIndex: zIndex || 10,
          color: 'rgba(0, 0, 0, 0.87)'
        }),
        content: (base) => ({
          ...base,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        })
      }}
    >
      {children}
    </LoadingOverlay>
  );
};

export default (LoadingOverlayWrapper);
